export default __webpack_public_path__ + "static/media/Info.50361a08.svg";